import { FormatDate } from "./types";

export const formatDate: FormatDate = ({ date }) => {
  return new Date(date).toLocaleDateString();
};
